
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Aulnay-sous-Bois dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Aulnay-sous-Bois certifiée Google Partner, accompagne les entreprises aulnaysiennes pour développer leur visibilité en ligne et générer de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Aulnay-sous-Bois dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Aulnay-sous-Bois certifiée Google Partner, accompagne les entreprises aulnaysiennes pour développer leur visibilité en ligne et générer de nouveaux clients.",
        },
      ],
    };
  },
};
